import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

/**
 * Opt a request out of the global loading indicator — useful for background
 * polling or prefetches that should not flash a spinner:
 *
 *   http.get(url, { context: new HttpContext().set(SKIP_LOADING, true) })
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

/**
 * Counts every in-flight request in LoadingService. `finalize` runs on
 * success, error and unsubscribe alike, so the counter cannot leak when a
 * request is cancelled mid-flight.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  const loading = inject(LoadingService);
  loading.start();

  return next(req).pipe(finalize(() => loading.stop()));
};
